<template>
    <v-hover>
        <v-card flat hover slot-scope="{ hover }">
            <v-card-text>
                <v-textarea
                        :label="(value.label)? value.label : d.label"
                        :hint="(value.hint)? value.hint : d.hint"
                        persistent-hint
                >
                </v-textarea>
                <div v-if="hover">
                    <br>
                    <v-divider></v-divider>
                    <v-layout>
                        <v-flex>
                            <v-text-field label="Etiqueta" v-model="d.label" @input="input"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Hint" v-model="d.hint" @input="input"></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        name: "tipotextarea",
        props: ['value'],
        data() {
            return {
                d: {
                    label: 'Etiqueta',
                    hint: 'hint'
                }

            }
        },
        methods: {
            input() {
                this.$emit('input', this.d);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/tipos/textarea.vue